import { wpPostApi } from "../APIManager/ApiManager"

export const direct_booking_Api=(data,headers)=>{
    return wpPostApi(`https://graph.facebook.com/${process.env.REACT_APP_VERSION}/${process.env.REACT_APP_PHONE_NUMBER_ID}/messages`,data,headers)
}